export const paths = {
  PLATFORM: 'platform',
  UNSUBSCRIBE: 'unsubscribe',
  AUTH: 'auth',
  SIGN_UP: 'sign-up',
  COOKIE_POLICY: 'cookie-policy',
  MAINTENANCE: 'maintenance',
  auth: {
    LOGIN: 'login',
    LOGIN_VERIFICATION: 'login-verification',
    ACCOUNT_SELECT: 'account-select',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    DELETE_ACCOUNT: 'delete-account',
    AUTH_TOKEN: 'token',
    AUTH_CODE: 'code',
    LOGIN_STATUS: 'signing-in',
  },
  platform: {
    DASHBOARD: 'dashboard',
    PROPERTIES: 'properties',
    PORTFOLIO_ITEM: 'portfolio-item',
    SMART_SEARCH: 'smart-search',
    SMART_SEARCH_DEAL: 'smart-search-deal',
    FIRST_TIME: 'first-time',
    MORTGAGES: 'mortgages',
    MORTGAGE_DETAIL: 'mortgage-detail',
    REMORTGAGE_ENQUIRY_DETAIL: 'remortgage-enquiry-detail',
    SMART_SEARCH_ENQUIRY_DETAIL: 'smart-search-enquiry-detail',
    HELP_ENQUIRY_DETAIL: 'help-enquiry-detail',
    HELP_CASE: 'enquiries',
    DOCUMENTS: 'documents',
    MAB_ARTICLES: 'mab-articles',
    PROPERTY: 'property',
    PROPERTY_CARD: 'property-card',
    SMART_SEARCH_CARD: 'smart-search-card',
    SMART_SEARCH_LIST: 'smart-search-list',
    BETTER_DEAL_OVERALL: 'better-deal-overall',
    BETTER_DEAL_COMPARISON: 'better-deal-comparison',
    REMORTGAGE_GUIDE: 'remortgage-guide',
    OPPORTUNITY_BETTER_DEAL_DETAIL: 'opportunity-better-deal-detail',
    PROFILE: 'profile',
    EPC: 'epc',
    INBOX: 'inbox',
    INBOX_MESSAGE_DETAIL: 'inbox-message-detail',
    ADVISOR: 'advisor',
    mortgages: {
      ADD: 'add',
      SEARCH_RESULTS: 'search-results',
    },
    property: {
      ADD: 'add',
      add: {
        ADDRESS: 'address',
      },
    },
    profile: {
      SEARCH_PREFERENCES: 'search-preferences',
      NOTIFICATIONS_SETTING: 'notification-settings',
      CREDIT_REPORT: 'credit-and-expenditure',
      INCOME: 'income-and-affordability',
      ACTIONS: 'actions',
      COOKIE_POLICY: 'cookie-policy',
      SECURITY: 'security',
    },
    mabArticles: {
      ARTICLE_DETAIL: 'article-detail',
    },
  },
  advisor: {
    ENQUIRIES: 'enquiries',
  },
  signUp: {
    Entry: 'entry',
    Property: 'property',
    Mortgage: 'mortgage',
    SmartSearch: 'smart-search',
    User: 'user',
    Landlord: 'landlord',
    WelcomeEmail: 'welcome-email',
    SignUpError: 'sign-up-error',
  },
} as const; // To ensure better typing (WTF Typescript)
